module.exports = __webpack_public_path__ + "media/widgets/join_500x600-adebac28.png";